export const getNotPlannedFontColor = (cellValue: number) => {
  if (cellValue === undefined || cellValue >= 0) {
    return undefined;
  }

  return 'alertDark';
};
